"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteNotice = deleteNotice;
exports.getNotice = getNotice;
exports.getNoticeList = getNoticeList;
exports.saveNotice = saveNotice;
exports.uploadPhoto = uploadPhoto;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
// 获取列表
function getNoticeList(query) {
  return (0, _requestAuth.default)({
    url: '/xyNotice/page',
    method: 'get',
    params: query
  });
}

// 添加
function saveNotice(data) {
  return (0, _requestAuth.default)({
    url: '/xyNotice/saveOrUpdate',
    method: 'post',
    data: data
  });
}

// 删除信息
function deleteNotice(id) {
  return (0, _requestAuth.default)({
    url: '/xyNotice?id=' + id,
    method: 'delete'
  });
}

// 通过id信息
function getNotice(id) {
  return (0, _requestAuth.default)({
    url: '/xyNotice/' + id,
    method: 'get'
  });
}
function uploadPhoto(params) {
  return (0, _requestAuth.default)({
    url: '/image/upload',
    method: 'post',
    data: params
  });
}